import { c as _c } from "react/compiler-runtime";
import { IcoLock16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
export type FieldProps = {
  label: string;
  value: unknown;
  isDecrypted: boolean;
  isEmpty: boolean;
};
const getText = (value: unknown) => {
  if (Array.isArray(value)) {
    return value.join(', ');
  }
  return typeof value === 'string' ? value : '';
};
const Field = t0 => {
  const $ = _c(21);
  const {
    label,
    value,
    isDecrypted,
    isEmpty
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.userData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== isDecrypted || $[2] !== isEmpty || $[3] !== label || $[4] !== t || $[5] !== value) {
    const text = getText(value);
    const renderValue = () => {
      if (!isDecrypted && !isEmpty) {
        return <span className="inline-flex items-center gap-1.5 align-top text-tertiary"><IcoLock16 color="tertiary" /><span aria-hidden={true}>••••••••</span><span className="sr-only">{t(_temp)}</span></span>;
      }
      return text || <span className="text-quaternary">–</span>;
    };
    t5 = "grid grid-cols-[fit-content(60%)_minmax(0,1fr)] gap-x-6 px-4 py-1.5";
    if ($[11] !== label) {
      t6 = <dt className="text-body-2 text-tertiary wrap-anywhere">{label}</dt>;
      $[11] = label;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t2 = "min-w-0 text-right text-body-2 text-primary wrap-anywhere";
    t3 = "mask";
    t4 = renderValue();
    $[1] = isDecrypted;
    $[2] = isEmpty;
    $[3] = label;
    $[4] = t;
    $[5] = value;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  if ($[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
    t7 = <dd className={t2} data-dd-privacy={t3}>{t4}</dd>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export default Field;
function _temp($) {
  return $.encrypted;
}